// Feature 009: Deal Operating System
// Action Cable consumer for real-time updates
import { createConsumer } from '@rails/actioncable';

export default createConsumer();
